import { Sector } from '@/domain/impact/impact.entity';
import { getScoreLetterFromScore } from '@/domain/impact-calculate/utils/get-score-letter-from-score';
import { CalculateFestivalEnv } from '@/domain/impact-calculate-festival/entities/calculate-festival-env.entity';
import { EnvTopic } from '@/domain/impact-env/entities/question.entity';
import { translate } from '@/ui/i18n';
import { TopicScoreDetailsData } from '@/ui/pages/app/components/topic-score-card/type';
import {
  formatUnit,
  getEnvTopicName,
} from '@/ui/utils/ess-env-names-and-format';

export function prepareScoreSectorDetailsDataEnv(
  calculateEnv: CalculateFestivalEnv,
  sector: Sector,
): TopicScoreDetailsData {
  return {
    value:
      sector !== '' ? calculateEnv.sectors[sector].score : calculateEnv.score,
    scoreLetter:
      sector &&
      calculateEnv.sectors[sector].score &&
      calculateEnv.sectors[sector].maxScore
        ? getScoreLetterFromScore(
            calculateEnv.sectors[sector].score /
              calculateEnv.sectors[sector].maxScore,
          )
        : '-',
    refValue: NaN,
    maxValue: (sector && calculateEnv.sectors[sector].maxScore) || NaN,
    completion: NaN,
    sections: [
      {
        name: translate('Projects.details'),
        items: [
          {
            id: 'FOOD_BEVERAGES',
            name: getEnvTopicName(EnvTopic.FOOD_BEVERAGES),
            value: calculateEnv.topics.FOOD_BEVERAGES.score,
            unit: formatUnit(calculateEnv.topics.FOOD_BEVERAGES.maxScore),
          },
          {
            id: 'RESOURCES_POLLUTION',
            name: getEnvTopicName(EnvTopic.RESOURCES_POLLUTION),
            value: calculateEnv.topics.RESOURCES_POLLUTION.score,
            unit: formatUnit(calculateEnv.topics.RESOURCES_POLLUTION.maxScore),
          },
          {
            id: 'COMMUNICATION',
            name: getEnvTopicName(EnvTopic.COMMUNICATION),
            value: calculateEnv.topics.COMMUNICATION.score,
            unit: formatUnit(calculateEnv.topics.COMMUNICATION.maxScore),
          },
          {
            id: 'PUBLIC_ENGAGEMENT',
            name: getEnvTopicName(EnvTopic.PUBLIC_ENGAGEMENT),
            value: calculateEnv.topics.PUBLIC_ENGAGEMENT.score,
            unit: formatUnit(calculateEnv.topics.PUBLIC_ENGAGEMENT.maxScore),
          },
        ],
      },
    ],
  };
}
